import useWorkspaceAccessControl from '@/components/WorkspaceAccessControl/hooks/useWorkspaceAccessControl';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { UserStatusEnum, WorkspaceActions, WorkspaceSubjects } from '@/types/schema';

interface Params {
  learnerId: string;
  learnerStatus: UserStatusEnum;
}

const useMasqueradeAction = ({ learnerId, learnerStatus }: Params) => {
  const user = useUserContext();

  const { canAccess } = useWorkspaceAccessControl(
    WorkspaceActions.Masquerade,
    WorkspaceSubjects.User,
  );

  const canMasquerade =
    canAccess && learnerStatus === UserStatusEnum.Active && user.id !== learnerId;

  return { canMasquerade };
};

export default useMasqueradeAction;
